import { Component, OnInit, ViewChild } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NavController, NavParams } from '@ionic/angular';
import { Category, CategoryService, Feature, FeatureService, ManufacturerService, Product, ProductService } from 'octali-lib-shop';
import { Location } from '@angular/common';
import { ProductsListPanelViewComponent } from 'src/app/components/product/products-list-panel-view/products-list-panel-view.component';
import { combineLatest } from 'rxjs';
import { CategoryFilterPanelComponent } from 'src/app/components/category/category-filter-panel/category-filter-panel.component';

@Component({
  selector: 'app-category',
  templateUrl: './category.page.html',
  styleUrls: ['./category.page.scss'],
})
export class CategoryPage implements OnInit {

  @ViewChild('productsList', { read: ProductsListPanelViewComponent, static: true }) productsList: ProductsListPanelViewComponent;
  @ViewChild('featuresList', { read: CategoryFilterPanelComponent, static: false }) featuresList: CategoryFilterPanelComponent;

  private categoryId:string;
  public category: Category;
  public products: Array<Product>;
  public productsFiltered: Array<Product>;
  public filters:Map<any,any>;
  private featuresId:Map<string,Feature>;
  private start:any = null;
  private featuresFilters:Map<any,any>= new Map<any,any>();

  private title:string ="";
  
  constructor(
    private activatedRoute: ActivatedRoute,
    private productService: ProductService,
    private categoryService: CategoryService,
    private _location: Location,
    private titleService: Title, 
    private meta: Meta,
    private manufacturerService: ManufacturerService,
    private navCtrl: NavController,
    private featureService: FeatureService,
    private router: Router
  ) { 
    this.products = [];
    this.productsFiltered = [];
    this.filters = new Map<any,any>();
  }

  async ngOnInit() {
    this.categoryId = await this.activatedRoute.snapshot.paramMap.get('id');
    combineLatest( [
      this.categoryService.getCategoriesIdObs(),
      this.productService.getProductsByCatObs(),
      this.featureService.getFeaturesIdObs()
    ] )
    .subscribe( ([categoriesId, products, featuresId ]) => {
      if( categoriesId && products && featuresId ){
        this.featuresId = featuresId;
        if( categoriesId.has( this.categoryId ) ) {
          this.category = categoriesId.get( this.categoryId )

          this.title = "Dégriff'laine - "+this.category.name;
          this.titleService.setTitle(this.title);
          this.meta.updateTag({ property: 'og:title', content:this.title });

          this.products = [];
          if( products.has( this.categoryId ) )
            for(let prod of products.get( this.categoryId ) )
              if(prod.statut == "publish")
                this.products.push(prod);
          this.productsList.setProducts( this.products );
          this.featuresList.setCategory(this.category);
        }
      }
    });
    
  }

  select( prod ){
    let manId = this.manufacturerService.getManufacturersIdObs().getValue();
    let title = prod.title.replace(/\/|\s/g, "-").toLowerCase();
    let cat = this.category.name.replace(/\/|\s/g, "-").toLowerCase();
    if (manId.has(prod.manufacturer) && manId.get(prod.manufacturer).name != "" ){
      let man = manId.get(prod.manufacturer).name.replace(/\/|\s/g, "-").toLowerCase();
      this.navCtrl.navigateForward("/produits/"+encodeURI(cat)+"/"+encodeURI(man)+"/"+encodeURI(title)+"/"+prod.id);
    }else
    if(title != "")
      this.navCtrl.navigateForward("/produits/"+encodeURI(prod.title)+"/"+prod.id);
  }


  filterProducts(products): Array<Product> {
    let results: Array<Product>= [];
    let insert:boolean = false;
    for(let product of products) {
      insert = true;
      if( product.features == null || product.features.length == 0 ) {
        insert = false;
      } else {
        for(let featureKey of this.featuresFilters.keys()){
          if( !product.features.has(featureKey)){
            insert = false;
            
          }else{
            let valuesF = this.featuresFilters.get( featureKey );
            if(this.featuresId.get(featureKey).multiple){
              if( this.featuresId.get( featureKey ).type == "map" ){
                if (valuesF.some( r => { 
                  let ins = true; 
                  for(let featureName of this.featuresId.get(featureKey).nameValue) {
                    for(let feature of product.features.get( featureKey )){
                      if(feature[featureName] != r[featureName])
                        ins = false;
                    }
                  }
                  return ins;
                } )) {
                }else
                  insert = false;
              }else{
                if(product.features.get( featureKey ).some( r => {
                  if( r instanceof Object)
                    return valuesF.includes(r.name);
                  else
                    return valuesF.includes(r);
                })){
                }else
                  insert = false;
              }
            }else{
              if( this.featuresId.get( featureKey ).type == "map" ){
                if (valuesF.some( r => { 
                  let ins = true; 
                  for(let featureName of this.featuresId.get(featureKey).nameValue) {
                    for(let feature of product.features.get( featureKey )){
                      if(feature[featureName] != r[featureName])
                        ins = false;
                    }
                  }
                  return ins;
                } )) {
                }else
                  insert = false;
              } else {
                if (valuesF.some( r => product.features.get( featureKey ).includes(r))){
                }else
                  insert = false;
              }
            }
          }
            
        }
      }
      if(insert)
        results.push(product);
    }
    return results;
  }

  filter( features:Map<any,any> ){
    this.featuresFilters = features;
    if( features.size > 0 ){
      this.productsFiltered = this.filterProducts( this.products );
      this.productsList.setProducts( this.productsFiltered );
    } else {
      this.productsFiltered = [];
      this.productsList.setProducts( this.products );
    }
  }
}
